function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-809553eb-cc4a-4926-ac7e-fafbe13b37b7",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m23.875,27h-15.75c-1.723,0-3.125-1.402-3.125-3.125v-15.75c0-1.723,1.402-3.125,3.125-3.125h15.75c1.723,0,3.125,1.402,3.125,3.125v15.75c0,1.723-1.402,3.125-3.125,3.125ZM8.125,8c-.069,0-.125.056-.125.125v15.75c0,.069.056.125.125.125h15.75c.069,0,.125-.056.125-.125v-15.75c0-.069-.056-.125-.125-.125h-15.75Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/Stop.bf2cc67dd07e1e84e578e77b06bd19ad.svg";
export { ForwardRef as ReactComponent };